import HealthLevels from './HealthLevels';

export default {
  [HealthLevels.NA]: 'NA',
  [HealthLevels.GO]: 'Green - Go',
  [HealthLevels.SLOW]: 'Yellow - Slow',
  [HealthLevels.WHOA]: 'Red - Whoa!'
};
